'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isNan = require('babel-runtime/core-js/number/is-nan');

var _isNan2 = _interopRequireDefault(_isNan);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _AliasRewriter = require('./AliasRewriter');

var _AliasRewriter2 = _interopRequireDefault(_AliasRewriter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inputCommands = {};

var InputHandler = function () {
    function InputHandler(state) {
        var _this = this;

        (0, _classCallCheck3.default)(this, InputHandler);

        this.state = state;
        this.aliasRewriter = new _AliasRewriter2.default();

        this.aliasRewriter.importFromString(state.setting('aliases'));

        state.$watch('user_settings.aliases', function (newVal) {
            _this.aliasRewriter.importFromString(state.setting('aliases'));
        });

        this.listenForInput();
    }

    (0, _createClass3.default)(InputHandler, [{
        key: 'defaultContext',
        value: function defaultContext() {
            return {
                network: this.state.getActiveNetwork(),
                buffer: this.state.getActiveBuffer()
            };
        }
    }, {
        key: 'validateContext',
        value: function validateContext(context) {
            if ((typeof context === 'undefined' ? 'undefined' : (0, _typeof3.default)(context)) !== 'object' || !Object.prototype.hasOwnProperty.call(context, 'buffer') || !Object.prototype.hasOwnProperty.call(context, 'network') || (0, _typeof3.default)(context.buffer) !== 'object' || (0, _typeof3.default)(context.network) !== 'object') {
                throw new TypeError('context must contain both network and buffer properties');
            }
        }
    }, {
        key: 'listenForInput',
        value: function listenForInput() {
            var _this2 = this;

            this.state.$on('input.raw', function (input) {
                var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.defaultContext();

                var lines = input.split('\n');
                lines.forEach(function (line) {
                    return _this2.processLine(line, context);
                });
            });
        }
    }, {
        key: 'processLine',
        value: function processLine(rawLine) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultContext();

            this.validateContext(context);
            var network = context.network,
                buffer = context.buffer;

            var line = rawLine;
            var stylesStrippedLine = Misc.stripStyles(line);

            var escapedCommand = stylesStrippedLine.substr(0, 2) === '//';
            if (stylesStrippedLine[0] !== '/' || escapedCommand) {
                if (escapedCommand) {
                    line = line.substr(1);
                }

                if (buffer.isServer()) {
                    line = '/quote ' + line;
                } else {
                    line = '/msg ' + buffer.name + ' ' + line;
                }
            } else if (stylesStrippedLine[0] === '/' && line[0] !== '/') {
                line = stylesStrippedLine;
            }

            var aliasVars = {
                network: network.name,
                server: network.connection.server,
                channel: network.isChannelName(buffer.name) ? buffer.name : '',
                query: network.isChannelName(buffer.name) ? '' : buffer.name,
                destination: buffer.name,
                nick: network.nick
            };
            line = this.aliasRewriter.process(line, aliasVars);

            if (!line) {
                return;
            }

            line = line.substr(1);

            var spaceIdx = line.indexOf(' ');
            if (spaceIdx === -1) spaceIdx = line.length;

            var command = line.substr(0, spaceIdx);
            var params = line.substr(spaceIdx + 1);

            var eventObj = {
                handled: false,
                raw: rawLine,
                command: command,
                params: params
            };

            this.state.$emit('input.command.' + command, eventObj, command, params);
            if (eventObj.handled) {
                return;
            }

            if (inputCommands[command.toLowerCase()]) {
                inputCommands[command.toLowerCase()].call(this, eventObj, command, params);
            }

            if (!eventObj.handled) {
                network.ircClient.raw(line);
            }
        }
    }]);
    return InputHandler;
}();

exports.default = InputHandler;

inputCommands.lines = function inputCommandLines(event, command, line) {
    var _this3 = this;

    event.handled = true;

    line.split('|').forEach(function (subLine) {
        _this3.processLine(subLine.trim());
    });
};

function handleMessage(type, event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();

    var spaceIdx = line.indexOf(' ');
    if (spaceIdx === -1) spaceIdx = line.length;

    var bufferName = line.substr(0, spaceIdx);
    var message = line.substr(spaceIdx + 1);

    if (!message) {
        return;
    }

    var localBuffer = bufferName;
    var extractedTarget = network.ircClient.network.extractTargetGroup(bufferName);
    if (extractedTarget) {
        localBuffer = extractedTarget.target;
    }

    var buffer = localBuffer.length && this.state.getOrAddBufferByName(network.id, localBuffer);
    if (buffer) {
        var textFormatType = 'privmsg';
        if (type === 'action') {
            textFormatType = 'action';
        } else if (type === 'notice') {
            textFormatType = 'notice';
        }

        var messageBody = TextFormatting.formatText(textFormatType, {
            nick: network.nick,
            text: message
        });

        var newMessage = {
            time: Date.now(),
            nick: network.nick,
            message: messageBody,
            type: type
        };

        this.state.addMessage(buffer, newMessage);
    }

    var fnNames = {
        privmsg: 'say',
        action: 'action',
        notice: 'notice'
    };
    var fnName = fnNames[type] || 'say';
    network.ircClient[fnName](bufferName, message);
}

inputCommands.msg = function inputCommandMsg(event, command, line) {
    handleMessage.call(this, 'privmsg', event, command, line);
};
inputCommands.action = function inputCommandMsg(event, command, line) {
    handleMessage.call(this, 'action', event, command, line);
};
inputCommands.notice = function inputCommandMsg(event, command, line) {
    handleMessage.call(this, 'notice', event, command, line);
};
inputCommands.dice = function inputCommandDice(event, command, line) {
    var buffer = this.state.getActiveBuffer();
    var network = this.state.getActiveNetwork();

    var sides = line.replace(/\D/g, '');
    sides = parseInt(sides || '0', 10);
    if (sides <= 0) {
        sides = 6;
    }
    var rndNumber = Math.floor(Math.random() * sides) + 1;

    var msg = TextFormatting.t('dice_roll', {
        sides: TextFormatting.formatNumber(sides),
        number: TextFormatting.formatNumber(rndNumber)
    });
    network.ircClient.action(buffer.name, msg);
    this.state.addMessage(buffer, {
        nick: network.nick,
        message: msg,
        type: 'action'
    });
};

inputCommands.ctcp = function inputCommandCtcp(event, command, line) {
    var _network$ircClient;

    event.handled = true;

    var params = line.split(' ');
    var target = params.shift();
    var ctcpType = params.shift();

    if (!ctcpType || !target) {
        return;
    }

    var network = this.state.getActiveNetwork();
    (_network$ircClient = network.ircClient).ctcpRequest.apply(_network$ircClient, (0, _toConsumableArray3.default)([target, ctcpType].concat(params)));
};

inputCommands.join = function inputCommandJoin(event, command, line) {
    var _this4 = this;

    event.handled = true;

    var network = this.state.getActiveNetwork();
    var bufferObjs = Misc.extractBuffers(line);

    if (bufferObjs.length === 0) {
        var buffer = this.state.getActiveBuffer();

        if (buffer.isChannel() && !buffer.joined) {
            network.ircClient.join(buffer.name, buffer.key);
            return;
        }

        this.state.addMessage(buffer, {
            nick: '*',
            message: TextFormatting.t('error_no_channel_join'),
            type: 'error'
        });
        return;
    }

    var hasSwitchedActiveBuffer = false;
    bufferObjs.forEach(function (bufferObj, idx) {
        if (bufferObj.name === '0') {
            return;
        }

        var chanName = network.isChannelName(bufferObj.name) ? bufferObj.name : '#' + bufferObj.name;

        var newBuffer = _this4.state.addBuffer(network.id, chanName);

        if (newBuffer && !hasSwitchedActiveBuffer) {
            _this4.state.setActiveBuffer(network.id, newBuffer.name);
            hasSwitchedActiveBuffer = true;
        }

        if (bufferObj.key) {
            newBuffer.key = bufferObj.key;
        }

        network.ircClient.join(chanName, bufferObj.key);
    });
};

inputCommands.part = function inputCommandPart(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var bufferNames = [];
    var message = '';

    if (line === '') {
        bufferNames = [this.state.getActiveBuffer().name];
    } else {
        var lineParts = line.split(' ');
        if (network.isChannelName(lineParts[0])) {
            bufferNames = _lodash2.default.compact(lineParts[0].split(','));
            message = lineParts.slice(1).join(' ');
        } else {
            bufferNames = [this.state.getActiveBuffer().name];
            message = line;
        }
    }

    bufferNames.forEach(function (bufferName) {
        network.ircClient.part(bufferName, message);
    });
};

inputCommands.quit = function inputCommandQuit(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    network.ircClient.quit(line);
};

inputCommands.topic = function inputCommandTopic(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var bufferName = '';
    var newTopic = '';

    if (line === '') {
        return;
    }

    var lineParts = line.split(' ');
    if (network.isChannelName(lineParts[0])) {
        bufferName = lineParts[0];
        newTopic = lineParts.slice(1).join(' ');
    } else {
        bufferName = this.state.getActiveBuffer().name;
        newTopic = line;
    }

    network.ircClient.setTopic(bufferName, newTopic);
};

inputCommands.kick = function inputCommandKick(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var toKick = '';
    var bufferName = '';
    var kickReason = '';

    if (line === '') {
        return;
    }

    var lineParts = line.split(' ');

    if (network.isChannelName(lineParts[0])) {
        bufferName = lineParts.shift();
    }

    toKick = lineParts.shift();
    kickReason = lineParts.join(' ');

    if (!bufferName) {
        bufferName = this.state.getActiveBuffer().name;
    }
    if (!toKick) {
        return;
    }

    network.ircClient.raw('KICK', bufferName, toKick, kickReason);
};

inputCommands.ignore = function inputCommandIgnore(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var toIgnore = line.split(' ').shift();

    if (!toIgnore) {
        return;
    }

    var user = this.state.getUser(network.id, toIgnore);
    if (user) {
        user.ignore = true;
        var buffer = this.state.getActiveBuffer();
        this.state.addMessage(buffer, {
            nick: '*',
            message: 'Ignoring ' + user.nick,
            type: 'message'
        });
    }
};

inputCommands.unignore = function inputCommandUnignore(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var toUnignore = line.split(' ').shift();

    if (!toUnignore) {
        return;
    }

    var user = this.state.getUser(network.id, toUnignore);
    if (user) {
        user.ignore = false;
        var buffer = this.state.getActiveBuffer();
        this.state.addMessage(buffer, {
            nick: '*',
            message: 'No longer ignoring ' + user.nick,
            type: 'message'
        });
    }
};

inputCommands.close = function inputCommandClose(event, command, line) {
    var _this5 = this;

    event.handled = true;

    var network = this.state.getActiveNetwork();
    var bufferNames = _lodash2.default.compact(line.split(/[, ]/));
    if (bufferNames.length === 0) {
        bufferNames = [this.state.getActiveBuffer().name];
    }

    bufferNames.forEach(function (bufferName) {
        var buffer = network.bufferByName(bufferName);
        if (!buffer) {
            return;
        }

        _this5.state.removeBuffer(buffer);
    });
};

inputCommands.query = function inputCommandQuery(event, command, line) {
    event.handled = true;

    var pos = line.indexOf(' ');
    if (pos === -1) {
        pos = line.length;
    }

    var nick = line.substr(0, pos);
    var message = line.substr(pos + 1);

    var network = this.state.getActiveNetwork();
    var buffer = this.state.getOrAddBufferByName(network.id, nick);

    this.state.setActiveBuffer(network.id, buffer.name);

    if (message) {
        this.state.$emit('input.raw', '/msg ' + buffer.name + ' ' + message);
    }
};

inputCommands.invite = function inputCommandInvite(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var buffer = this.state.getActiveBuffer();

    var lineParts = line.split(' ');
    var nick = lineParts.shift();
    var channel = lineParts.shift();

    if (!channel) {
        channel = buffer.name;
    }

    if (!network.isChannelName(channel)) {
        return;
    }

    network.ircClient.raw('INVITE', nick, channel);
    this.state.addMessage(buffer, {
        nick: '*',
        message: 'Invited ' + nick + ' to ' + channel,
        type: 'message'
    });
};

inputCommands.nick = function inputCommandNick(event, command, line) {
    event.handled = true;

    var spaceIdx = line.indexOf(' ');
    if (spaceIdx === -1) spaceIdx = line.length;

    var newNick = line.substr(0, spaceIdx);
    var network = this.state.getActiveNetwork();
    network.ircClient.changeNick(newNick);
};

inputCommands.away = function inputCommandAway(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    network.ircClient.raw('AWAY', line || 'Currently away');
};

inputCommands.back = function inputCommandAway(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    network.ircClient.raw('AWAY');
};

inputCommands.quote = function inputCommandQuote(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();

    if (line.split(' ')[0].toLowerCase() === 'cap') {
        network.setting('show_raw_caps', true);
    }

    var buffer = this.state.getActiveBuffer();
    if (buffer.isServer()) {
        this.state.addMessage(buffer, {
            time: Date.now(),
            nick: '',
            message: line
        });
    }

    network.ircClient.raw(line);
};

inputCommands.whois = function inputCommandWhois(event, command, line) {
    var _this6 = this;

    event.handled = true;

    var parts = line.split(' ');
    var network = this.state.getActiveNetwork();
    var buffer = this.state.getActiveBuffer();

    network.ircClient.whois(parts[0], parts[0], function (whoisData) {
        if (whoisData.error) {
            var messageBody = TextFormatting.formatText('whois_error', {
                nick: whoisData.nick,
                text: whoisData.error
            });
            _this6.state.addMessage(buffer, {
                time: Date.now(),
                nick: '',
                message: messageBody,
                type: 'error'
            });
            return;
        }

        var out = [];
        var display = function display(message) {
            if (!message) {
                return;
            }

            out.push(message);
        };
        var formats = {
            mask: 'is {{nick}}!{{user}}@{{host}} * ({{real_name}})',
            from: 'is connecting from {{actual_hostname}} {{actual_ip}}',
            channels: 'is on {{channels}}',
            server: 'is using {{server}} ({{server_info}})',
            operator: '{{operator}}',
            modes: '{{modes}}',
            account: 'is logged in as {{account}}',
            registered_nick: '{{registered_nick}}',
            secure: 'is using a secure connection',
            idle: 'has been idle for {{idle}}',
            logon: 'connected on {{logon}}',

            nick: '',
            user: '',
            ident: '',
            hostname: '',
            real_name: '',
            actual_ip: '',
            server_info: '',
            actual_hostname: ''
        };

        if (whoisData.nick && whoisData.hostname) {
            display(formats.mask.replace('{{nick}}', whoisData.nick).replace('{{user}}', whoisData.ident).replace('{{host}}', whoisData.hostname).replace('{{real_name}}', whoisData.real_name));
        }
        if (whoisData.actual_hostname && whoisData.actual_ip) {
            display(formats.from.replace('{{actual_hostname}}', whoisData.actual_hostname).replace('{{actual_ip}}', whoisData.actual_ip));
        }
        if (whoisData.channels) {
            display(formats.channels.replace('{{channels}}', whoisData.channels));
        }
        if (whoisData.server) {
            display(formats.server.replace('{{server}}', whoisData.server).replace('{{server_info}}', whoisData.server_info));
        }
        if (whoisData.operator) {
            display(formats.operator.replace('{{operator}}', whoisData.operator));
        }
        if (whoisData.modes) {
            display(formats.modes.replace('{{modes}}', whoisData.modes));
        }
        if (whoisData.account) {
            display(formats.account.replace('{{account}}', whoisData.account));
        }
        if (whoisData.registered_nick) {
            display(formats.registered_nick.replace('{{registered_nick}}', whoisData.registered_nick));
        }
        if (whoisData.secure) {
            display(formats.secure);
        }
        if (whoisData.idle) {
            var idleSeconds = Math.floor(parseInt(whoisData.idle, 10));
            display(formats.idle.replace('{{idle}}', TextFormatting.formatDuration(idleSeconds)));
        }
        if (whoisData.logon) {
            var logonTime = parseInt(whoisData.logon, 10);
            if (!(0, _isNan2.default)(logonTime)) {
                var logonDate = new Date(logonTime * 1000);
                display(formats.logon.replace('{{logon}}', logonDate));
            }
        }

        _lodash2.default.each(whoisData, function (val, key) {
            if (typeof formats[key] === 'undefined') {
                if (_lodash2.default.isArray(val)) {
                    val.forEach(function (v) {
                        return display(key + ': ' + v);
                    });
                } else {
                    display(key + ': ' + val);
                }
            }
        });

        out.forEach(function (l) {
            _this6.state.addMessage(buffer, {
                nick: parts[0],
                message: l,
                type: 'whois'
            });
        });
    });
};

inputCommands.whowas = function inputCommandWhowas(event, command, line) {
    var _this7 = this;

    event.handled = true;

    var parts = line.split(' ');
    var network = this.state.getActiveNetwork();
    var buffer = this.state.getActiveBuffer();

    network.ircClient.whowas(parts[0], parts[0], function (whowasData) {
        if (whowasData.error) {
            var messageBody = TextFormatting.formatText('whowas_error', {
                nick: whowasData.nick,
                text: whowasData.error
            });
            _this7.state.addMessage(buffer, {
                time: Date.now(),
                nick: '',
                message: messageBody,
                type: 'whowas'
            });
            return;
        }

        ['whowas_ident', 'whowas_server'].forEach(function (prop) {
            var messageBody = TextFormatting.formatText(prop, {
                nick: whowasData.nick,
                ident: whowasData.ident,
                host: whowasData.hostname,
                name: whowasData.real_name,
                server: whowasData.server,
                info: whowasData.server_info
            });

            _this7.state.addMessage(buffer, {
                time: Date.now(),
                nick: whowasData.nick,
                message: messageBody,
                type: 'whowas'
            });
        });
    });
};

inputCommands.mode = function inputCommandMode(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var buffer = this.state.getActiveBuffer();
    var target = buffer.isChannel() ? buffer.name : network.nick;

    var parts = _lodash2.default.compact(line.split(' '));

    if (line && line[0] !== '+' && line[0] !== '-') {
        target = parts.shift();
    }

    if (parts[0]) {
        if (parts[0] === '+b' && !parts[1]) {
            buffer.flags.requested_banlist = true;

            setTimeout(function () {
                buffer.flags.requested_banlist = false;
            }, 4000);
        }

        network.ircClient.mode(target, parts[0], parts[1]);
    } else {
        network.ircClient.mode(target);

        if (target === buffer.name) {
            buffer.flags.requested_modes = true;
            setTimeout(function () {
                buffer.flags.requested_modes = false;
            }, 4000);
        }
    }
};

inputCommands.names = function inputCommandNames(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    var args = line;

    if (!args) {
        args = this.state.getActiveBuffer().name;
    }

    network.ircClient.raw('NAMES ' + args);
};

inputCommands.clear = function inputCommandClear(event, command, line) {
    event.handled = true;

    var buffer = this.state.getActiveBuffer();
    buffer.clearMessages();

    this.state.addMessage(buffer, {
        nick: '*',
        message: 'Scrollback cleared'
    });
};

inputCommands.echo = function inputCommandEcho(event, command, line) {
    event.handled = true;

    var buffer = this.state.getActiveBuffer();

    this.state.addMessage(buffer, {
        nick: '*',
        message: line
    });
};

inputCommands.set = function inputCommandEcho(event, command, line) {
    event.handled = true;

    var buffer = this.state.getActiveBuffer();

    var setting = '';
    var spacePos = line.indexOf(' ');

    if (spacePos > -1) {
        setting = line.substr(0, spacePos);
        var value = line.substr(spacePos + 1).trim();
        switch (value.toLowerCase().trim()) {
            case 'true':
            case 'on':
                value = true;
                break;
            case 'false':
            case 'off':
                value = false;
                break;
            default:
        }

        if (value[0] === '"' && value[value.length - 1] === '"') {
            value = value.substr(1, value.length - 2);
        }

        this.state.setting(setting, value);
    } else {
        setting = line;
    }

    this.state.addMessage(buffer, {
        nick: '*',
        message: setting + ' = ' + this.state.setting(setting)
    });
};

inputCommands.list = function inputCommandList(event, command, line) {
    event.handled = true;

    var network = this.state.getActiveNetwork();
    if (!network.channel_list.length && network.channel_list_state !== 'updating') {
        network.channel_list_state = 'updating';
        network.ircClient.raw('LIST ' + line);
    }

    network.showServerBuffer('channels');
};

inputCommands.server = function inputCommandServer(event, command, line) {
    event.handled = true;

    var parts = line.split(' ');
    var serverAddr = parts[0];
    var serverPort = parts[1] || 6667;
    var serverTls = false;
    var serverPassword = parts[2];
    var nick = parts[3] || 'ircuser';

    if (serverPort[0] === '+') {
        serverTls = true;
        serverPort = parseInt(serverPort.substr(1), 10);
    } else {
        serverTls = false;
        serverPort = parseInt(serverPort, 10);
    }

    this.state.addNetwork(serverAddr, nick, {
        server: serverAddr,
        port: serverPort,
        tls: serverTls,
        password: serverPassword
    });
};

inputCommands.beep = function inputCommandBeep(event, command, line) {
    this.state.$emit('audio.bleep');
};

inputCommands.notify = function inputCommandNotify(event, command, line) {
    this.state.$emit('notification.show', line);
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["InputHandler"]
window._kiwi_exports.libs.InputHandler = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/InputHandler.js
// module id = ADMw
// module chunks = 1